import { render, staticRenderFns } from "./TheFormProfile.vue?vue&type=template&id=24010c88&scoped=true&"
import script from "./TheFormProfile.vue?vue&type=script&lang=ts&"
export * from "./TheFormProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24010c88",
  null
  
)

export default component.exports